import { render } from "./DashboardShippingSpreadsheetUpload.vue?vue&type=template&id=88830574"
import script from "./DashboardShippingSpreadsheetUpload.vue?vue&type=script&lang=js"
export * from "./DashboardShippingSpreadsheetUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__